import { render, staticRenderFns } from "./SmsCharge.vue?vue&type=template&id=51fe87ca&"
import script from "./SmsCharge.vue?vue&type=script&lang=js&"
export * from "./SmsCharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports